module.exports = __webpack_public_path__ + "static/media/general-view.b178d457.png";